
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import ProfileLayout from '@Components/Layout/profile';
import { Wrapper } from '@Components/ProfilePage/ProfilePage.styled';
import Terms from '@Components/TermsAndConditions/Terms';
type Props = {};

const TermsAndConditions = ({}: Props) => {
  return (
    <ProfileLayout seoData={{ title: 'Terms & Conditions' }} hideSideBar={true}>
      <Wrapper>
        <Terms />
      </Wrapper>
    </ProfileLayout>
  );
};

 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default TermsAndConditions;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/terms',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  